// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './stores'
import headerWrap from '@/components/header'
import footerWrap from '@/components/footer/index.vue'
import searchWrap from '@/components/search'
import secordNav from '@/components/secordHeader'
import BackButton from '@/components/BackButton.vue'
import CustomVideo from '@/components/CustomVideo.vue'

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import animated from 'animate.css' // 引入
import { convertPxToRem } from './utils/utils';
import './utils/rem'


Vue.config.productionTip = false
Vue.component('header-wrap', headerWrap)
Vue.component('footer-wrap', footerWrap)
Vue.component('search-wrap', searchWrap)
Vue.component('secord-nav', secordNav)
Vue.component('back-button', BackButton)
Vue.component('custom-video', CustomVideo)
Vue.prototype.$convertPxToRem = convertPxToRem; 
Vue.use(ElementUI, { locale })
Vue.use(animated) // 全局注册
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js